<template>
  <button-icon
    v-if="iconType === 'button-icon'"
    :name="symbolName"
    :size="size"
    v-bind="$attrs"
    @click="onClick"
  />
  <span v-else-if="iconType === 'slot-svg'" :class="['zm-icons', 'zm-icons--' + size]">
    <slot />
  </span>
  <svg
    v-else-if="iconType === 'slot-path'"
    aria-hidden="true"
    viewBox="0 0 16 16"
    :class="['zm-icons', 'zm-icons--' + size]"
  >
    <slot />
  </svg>
  <svg
    v-else
    aria-hidden="true"
    viewBox="0 0 16 16"
    :class="['zm-icons', 'zm-icons--' + size]"
  >
    <use :href="symbolName" :xlink:href="symbolName" />
  </svg>
</template>

<script>
  import buttonIcon from './button-icon';
  export default {
    name: 'ZmIcon',
    components: {
      buttonIcon
    },
    props: {
      name: {
        type: String,
        default: ''
      },
      size: {
        type: String,
        default: 'middle'
      }
    },
    data() {
      return {
        symbolName: ''
      };
    },
    computed: {
      iconType() {
        if (this.$listeners.click) {
          return 'button-icon';
        } else if (this.$slots && this.$slots.default) {
          if (this.$slots.default[0].tag === 'svg') {
            return 'slot-svg';
          } else {
            return 'slot-path';
          }
        } else {
          return 'normal';
        }
      }
    },
    watch: {
      name(newName) {
        if (!this.$slots.default) {
          this.getSVG(newName);
        }
      }
    },
    mounted() {
      if (!this.$slots.default) {
        this.getSVG(this.name);
      } else if (this.name) {
        console.error('Zm-icon do not support to use slot and name to load svg at the same time!');
      }
    },
    methods: {
      getSVG(name) {
        this.symbolName = `#${name}`;
        import(`../../scss/icon/${name}.svg`);
      },
      onClick() {
        this.$emit('click');
      }
    }
  };
</script>

<style lang="scss">
@import "./style.scss";
</style>
